import { render, staticRenderFns } from "./FundView.vue?vue&type=template&id=142c7c9e"
import script from "./FundView.vue?vue&type=script&lang=js"
export * from "./FundView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports